var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import JsonURL from '@jsonurl/jsonurl';
import { cleanObject } from '../utils/cleanObject';
export function useSetSearchURLData() {
    return (values, helpers) => __awaiter(this, void 0, void 0, function* () {
        const { query, filters, orderBy, modifiers } = values;
        const validatedFilters = cleanObject(filters);
        const validatedModifiers = cleanObject(modifiers);
        const searchParams = new URLSearchParams();
        if (validatedFilters) {
            const filterString = JsonURL.stringify(validatedFilters, { AQF: true }) || '';
            searchParams.append('filters', filterString);
        }
        if (orderBy) {
            const orderByString = JsonURL.stringify(orderBy, { AQF: true }) || '';
            searchParams.append('orderBy', orderByString);
        }
        if (query) {
            searchParams.append('query', query);
        }
        if (validatedModifiers) {
            const modifiersString = JsonURL.stringify(validatedModifiers, { AQF: true }) || '';
            searchParams.append('modifiers', modifiersString);
        }
        const urlSearchParamString = searchParams.toString();
        window.history.replaceState({}, '', `${window.location.pathname}?${urlSearchParamString}`);
        helpers.resetForm({ values });
    });
}
